import { createSlice } from "@reduxjs/toolkit";
import {
  choosePlanBuilder,
  fetchSubscriptionsBuilder,
  getSubscriptionsCreditsHistoryBuilder,
  rechargeCreditsBuilder,
} from "./builder";
import { LOGOUT } from "../../../utils/constants";

const initialState = {
  subscriptions: [],
  creditsHistory: {
    data: [],
    maxReached: false,
    total: 0,
    perPage: 10,
    page: 1,
    /* Start as loading: the SubscriptionPage triggers
       getSubscriptionsCreditsHistory on mount (gated on `loggedIn`),
       and we want the activity table's skeleton to render from the
       first paint instead of flashing the empty state for the frame
       between mount and the thunk's `pending` action. */
    loading: true,
    /* Set true after a successful page-1 fetch. The Header pre-loads
       this on login to decide between /subscription vs TopUp; once we
       have the answer, no need to refetch on every route mount. Reset
       on LOGOUT via the slice's initialState. */
    fetched: false,
  },
  choosePlanPending: false,
  rechargeCreditsPending: false,
  fetchSubscriptionsPending: false,
};

export const subscriptionSlice = createSlice({
  name: "subscriptionInfo",
  initialState,
  reducers: {
    resetState: () => initialState,
  },
  extraReducers: (builder) => {
    choosePlanBuilder(builder);
    fetchSubscriptionsBuilder(builder);
    rechargeCreditsBuilder(builder);
    getSubscriptionsCreditsHistoryBuilder(builder);

    builder.addCase(LOGOUT, (state) => ({
      ...initialState,
      subscriptions: state.subscriptions,
      loggedIn: false,
    }));
  },
});

export const { resetState } = subscriptionSlice.actions;

export const selectChoosePlanLoading = (state) =>
  state.subscriptionInfo.choosePlanPending;

export const selectRechargeCreditsLoading = (state) =>
  state.subscriptionInfo.rechargeCreditsPending;

export const selectFetchSubscriptionsLoading = (state) =>
  state.subscriptionInfo.fetchSubscriptionsPending;

export const selectCreditsHistory = (state) =>
  state.subscriptionInfo.creditsHistory;

export const selectCreditsHistoryFetched = (state) =>
  state.subscriptionInfo.creditsHistory.fetched;

export const selectSubscriptions = (state) =>
  state.subscriptionInfo.subscriptions;

export default subscriptionSlice.reducer;
